// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#app {\n  max-width: 10rem;\n  margin:  0 auto;\n  font-size: 0.37333rem;\n  letter-spacing: 0.02667rem;\n  height: 100%;\n}\n#nav {\n  padding: 0.8rem;\n}\n#nav a {\n  font-weight: bold;\n  color: #2c3e50;\n}\n#nav a.router-link-exact-active {\n  color: #42b983;\n}\n", ""]);
// Exports
module.exports = exports;
